import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@guryou/html-components';
import { stateIsLoading, stateIsNotInitialized } from '@guryou/redux';
import WidgetVideoDetails from './WidgetVideoDetails';

const WidgetVideos = () => {
  const { t } = useTranslation();
  const videos = useSelector(state => state.widget.videos);

  if (stateIsNotInitialized(videos)) {
    return null;
  }
  if (stateIsLoading(videos)) {
    return <Spinner />;
  }

  return (
    <div>
      {/* Header */}
      <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-4 lg:p-6 mb-4 lg:mb-6">
        <div className="flex items-center">
          <div
            className="p-2 lg:p-3 rounded-full mr-3 lg:mr-4"
            style={{
              backgroundColor: 'rgba(var(--feel-primary-rgb), 0.18)',
            }}
          >
            <svg className="w-5 h-5 text-feel-primary" viewBox="0 0 24 24" fill="currentColor">
              <path d="M10 16.5V7.5L16 12L10 16.5ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z" />
            </svg>
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-lg lg:text-2xl font-bold text-gray-900 mb-0.5 lg:mb-1 truncate">{t('GENERAL.videos')}</h2>
            <p className="text-sm lg:text-base text-gray-600 hidden sm:block">{t('WIDGET.videosDescription')}</p>
          </div>
        </div>
      </div>

      {/* Grid */}
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {videos.data.map((video, idx) => (
          <div key={`video_${idx}`} className="group">
            <div className="relative">
              <WidgetVideoDetails video={video} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WidgetVideos;
